import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faStore,
  faRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router";
const SidebarLinks = ({ links, onLinkClick }) => {
  // Map icon names to FontAwesome icons
  const iconMap = {
    home: faHome,
    upload: faStore,
    logOut: faRightFromBracket,
  };
  return (
    <div className="d-flex flex-column flex-shrink-0 p-3 ">
      <ul className="nav nav-underline flex-column" style={{ width: "100%" }}>
        {links.map((link, index) => (
          <li key={index} className="nav-item">
            <Link
              to={link.link}
              className={`nav-link  ${link.active ? "active" : ""}   `}
              aria-current="page"
              onClick={() => onLinkClick(link)}
              style={{
                width: "100%",
              }}
            >
              <FontAwesomeIcon
                icon={iconMap[link.icon]}
                className="me-2"
                size="lg"
              />
              {link.text}
            </Link>
            <hr className="m-1" />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SidebarLinks;
